import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'

// plugins

// import 'at-ui-style/css/at.css'
import './assets/css/main.scss'

// widget setup
// (optional) 'Custom elements polyfill'
import 'document-register-element/build/document-register-element'
// vue-custom-element by karol-f
// import vueCustomElement from 'vue-custom-element'
// Vue.use(vueCustomElement)

// import AtUI from 'at-ui'
// Vue.use(AtUI)
import { i18n } from './i18n-setup'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/vi'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI, { locale })

import * as VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
  locale: 'vi'
})
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.config.productionTip = false

// new Vue is not needed anymore, as you're initializing the app through vue-custom-element
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#o2o-survey-tool')

// use vue-custom-element
// App.store = store
// App.router = router
// Vue.customElement('o2o-survey-tool-widget', App)
